export const API_ROOT = process.env.REACT_APP_API_ROOT || 'https://kambio.digilabs.ca/';
export const GOOGLE_MAPS_KEY = 'AIzaSyAhNnpKjb5NiaxDVf5NNXKZxAOD7sKVx8M';
export const GOOGLE_GEOCODEAPI_KEY = 'AIzaSyCPlzUz1_Kxs0bEBVViUzbShKOhqoeFn7Q';
export const MOBILE_BREAKPOINT = 992;
